import { AuthClient } from "../authClient";
import { ENDPOINTS } from "../endpoints";
import { normalizeError } from "./errorHandler";

// const CLIENT_ID =
//   window.injectedEnv?.WE_ENV_CLIENT_ID || process.env.WE_ENV_CLIENT_ID;

const SCOPE_ID =
  //@ts-ignore
  window.injectedEnv?.WE_ENV_SCOPE_ID || process.env.WE_ENV_SCOPE_ID;

const authApi = new AuthClient({
  auth_url: ENDPOINTS.token(),
  authData: {
    scope: SCOPE_ID,
  },
  authContentType: "application/x-www-form-urlencoded",
});

function extendWithErrorHandler(
  method: AuthClient["patch"] | AuthClient["post"] | AuthClient["put"] | AuthClient["del"]
) {
  return async <T>(url: string, params?: any) => {
    return method<T>(url, params).catch((e) => {
      const error = normalizeError(e);
      if (error.type === "/user-is-blocked") {
        api.logout();
      }
      throw error;
    });
  };
}

export const api = {
  ...authApi,
  get: async <T>(url: string, params?: any) => {
    return authApi.get<T>(url, params).catch((e) => {
      const error = normalizeError(e);
      if (e.type === "/user-is-blocked") {
        api.dropToken();
      }
      throw error;
    });
  },
  post: extendWithErrorHandler(authApi.post),
  patch: extendWithErrorHandler(authApi.patch),
  put: extendWithErrorHandler(authApi.put),
  del: extendWithErrorHandler(authApi.del),
} as AuthClient;
